import { render, staticRenderFns } from "./EtebsList.vue?vue&type=template&id=52c0c396&"
import script from "./EtebsList.vue?vue&type=script&lang=js&"
export * from "./EtebsList.vue?vue&type=script&lang=js&"
import style0 from "./EtebsList.vue?vue&type=style&index=0&id=52c0c396&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports